import React, { Component } from 'react';
import Button from '../../artzu-ui/src/Button';
import Modal from '../../artzu-ui/src/Modal';
import { m } from '../../utils';
import { Mutation } from 'react-apollo';
import { withRouter, Link } from 'react-router-dom';
import gql from 'graphql-tag';
import ScrollLock from 'react-scrolllock';

const CANCEL_BOOKING = gql`
  mutation cancelBooking($id: Int!) {
    cancelBooking(id: $id) {
      bookingId
      startTime
      endTime
      feedback
    }
  }
`;
class DetailsOfBookings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelling: null,
      showCancel: false,
      cancelMessage: null,
      bookingCancelled: false,
    };
  }

  render() {
    const { formatShift, selectedBooking } = this.props;
    const { bookingCancelled } = this.state;
    if (selectedBooking) {
      return (
        <Mutation
          mutation={CANCEL_BOOKING}
          onCompleted={async ({ cancelBooking }) => {
            this.setState({ cancelling: 'completed' });
            // if(this.cancelModal && this.showCancelModal) {
            this.showCancelModal(
              `Booking on
                ${m(cancelBooking.startTime)
                  .toDate()
                  .toDateString()}
                from
                ${formatShift(m(cancelBooking.startTime).hour())}
                to
                ${formatShift(m(cancelBooking.endTime).hour())}
                was cancelled.`
            );
            // } else {
            //   setTimeout(window.location.reload(), 1000);
            // }
          }}>
          {cancelBooking => (
            <div className="details-container">
              {this.cancelModal ? this.cancelModal(cancelBooking) : null}
              <ScrollLock>
              <div className="booking-details">
                <div>
                  <h3>
                    {m(selectedBooking.startTime).isAfter(m())
                      ? 'Next Booking'
                      : m(selectedBooking.startTime).isBefore(m()) && m(selectedBooking.endTime).isAfter(m())
                      ? 'Current Booking'
                      : 'Previous Booking'}
                  </h3>
                </div>
                <div>
                  <strong>Booking ID</strong>
                  <p>{selectedBooking.stringIdentifier}</p>
                </div>
                <div>
                  <strong>Scheduled Time</strong>
                  <p>
                    {m(selectedBooking.startTime).format('dddd, MMM Do, YYYY')},{' '}
                    {formatShift(m(selectedBooking.startTime).hour())} to{' '}
                    {m(selectedBooking.endTime).format('dddd, MMM Do, YYYY')},{' '}
                    {formatShift(m(selectedBooking.endTime).hour())}
                  </p>
                </div>
                <div>
                  <strong>Duration</strong>
                  <p>{selectedBooking.duration} Hours</p>
                </div>
                <div>
                  <strong>Type of Vehicle</strong>
                  <p>Autzu {selectedBooking.vehicleClass.toUpperCase()}</p>
                </div>
                <div>
                  <strong>Parking Spot</strong>
                  <p>
                    {m(selectedBooking.startTime).subtract(10, 'minute').isAfter(m())
                      ? 'N/A'
                      : selectedBooking.car
                      ? selectedBooking.car.parkingSpot
                      : 'N/A'}
                  </p>
                </div>
                {m(selectedBooking.endTime)
                  .add(2, 'hour')
                  .isAfter(m()) &&
                m(selectedBooking.startTime)
                  .subtract(10, 'minute')
                  .isBefore(m()) &&
                selectedBooking.car ? (
                  <div>
                    <strong>Licence Plate</strong>
                    <p>{selectedBooking.car.plate}</p>
                  </div>
                ) : null}
                {m(selectedBooking.endTime)
                  .add(2, 'hour')
                  .isAfter(m()) &&
                m(selectedBooking.startTime)
                  .subtract(10, 'minute')
                  .isBefore(m()) &&
                selectedBooking.car ? (
                  <div>
                    <strong>Lockbox Code</strong>
                    <p>{selectedBooking.car.lockboxCode}</p>
                  </div>
                ) : null}
                <div>
                  <strong>Parking Lot</strong>
                  <p>{selectedBooking.parkinglot.address.streetAddress}</p>
                  <p>{selectedBooking.parkinglot.address.city}, {selectedBooking.parkinglot.address.province} {selectedBooking.parkinglot.address.postalCode}</p>
                </div>
                {m(selectedBooking.endTime)
                  .add(2, 'hour')
                  .isAfter(m()) &&
                  m(selectedBooking.startTime)
                    .subtract(10, 'minute')
                    .isBefore(m()) &&
                  selectedBooking.parkinglot && selectedBooking.parkinglot.accessCode ? (
                    <div>
                      <strong>Keypad Code</strong>
                      <p>{selectedBooking.parkinglot.accessCode}</p>
                    </div>
                  ) : null}
                <div>
                  <strong>Earnings</strong>
                  <p>{m(selectedBooking.startTime).isAfter(m()) ? 'N/A' : `$${selectedBooking.earnings.toFixed(2)}`}</p>
                </div>
              </div>
              </ScrollLock>
              <div className="details-footer">
                {selectedBooking.car ? (
                  <Link
                    to={{
                      pathname: '/report',
                      state: {
                        fromBooking: true,
                        bookingId: selectedBooking.id,
                        bookingTitle: `${m(selectedBooking.startTime).format('ddd, MMM. Do, hA')} - ${m(
                          selectedBooking.endTime
                        ).format('ddd, MMM. Do, hA')}`,
                        booking: selectedBooking
                      },
                    }}>
                    <Button className="report-button" label="Report Incident" color="#414141" fullWidth padding="0" />
                  </Link>
                ) : (
                  <Button
                    className="report-button"
                    label={bookingCancelled ? 'Booking Cancelled' : 'Cancel Booking'}
                    color="#414141"
                    fullWidth
                    disabled={
                      m(selectedBooking.startTime)
                        .subtract(48, 'hour')
                        .isAfter(m())
                        ? !!bookingCancelled
                        : true
                    }
                    padding="0"
                    onClick={() => {
                      this.setState({ showCancel: true });
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </Mutation>
      );
    }
    return (
      <div className="default-details">
        <strong>Select a booking to display details</strong>
      </div>
    );
  }

  showCancelModal = (reason = null) => {
    this.setState({ showCancel: true, cancelMessage: reason });
  };

  cancelModal = cancelBooking => {
    const { showCancel, cancelMessage, cancelling } = this.state;
    const { selectedBooking } = this.props;
    return (
      <Modal open={showCancel}>
        <div className="cancel-modal">
          <p>{cancelling && cancelling !== 'completed' ? 'Please wait...' : cancelMessage || 'Are you sure?'}</p>
          {cancelling === 'completed' ? null : (
            <Button
              color="#414141"
              className="cancel-butt"
              margin="1em 0 0 0"
              disabled={cancelling && cancelling !== 'completed'}
              onClick={() => {
                this.setState({ showCancel: false, cancelMessage: null });
              }}
              label="No"
            />
          )}
          <Button
            color={cancelling === 'completed' ? '#414141' : '#128dff'}
            className="cancel-butt"
            margin="1em 0 0 0"
            disabled={cancelling && cancelling !== 'completed'}
            onClick={
              cancelling === 'completed'
                ? () => {
                    this.setState({
                      cancelling: false,
                      showCancel: false,
                      cancelMessage: null,
                      bookingCancelled: true,
                    });
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }
                : () => {
                    this.setState({ cancelling: true });
                    cancelBooking({
                      variables: { id: parseInt(selectedBooking.id, 10) },
                    });
                  }
            }
            label={cancelling === 'completed' ? 'Close' : 'Yes'}
          />
        </div>
      </Modal>
    );
  };
}

export default withRouter(DetailsOfBookings);



// WEBPACK FOOTER //
// ./src/components/MyBookings/DetailsOfBookings.js